import { createModel } from "@rematch/core"

import { RootModel } from "./index"

export interface SearchState {
  lastSearchResult: string
  searchValue: string
}

const search = createModel<RootModel>()({
  effects: () => ({}),
  name: "search",
  reducers: {
    setLastSearchResult(state: SearchState, lastSearchResult: string) {
      return {
        ...state,
        lastSearchResult,
      }
    },
    setSearchValue(state: SearchState, searchValue: string) {
      return {
        ...state,
        searchValue,
      }
    },
  },
  selectors: () => ({}),
  state: {
    lastSearchResult: "",
    searchValue: "",
  } as SearchState,
})

export default search
